import api from '@/services/api.service';

export default {
  name: 'list',
  components: {},
  props: {
      caption: {
          type: String,
          default: 'Upload Response list'
      },
      hover: {
          type: Boolean,
          default: true
      },
      striped: {
          type: Boolean,
          default: true
      },
      bordered: {
          type: Boolean,
          default: false
      },
      small: {
          type: Boolean,
          default: false
      },
      fixed: {
          type: Boolean,
          default: false
      }
  },
  data () {
    return {
      items: [],
            fields: [
            // { key: '#' },
            { key: 'title', sortable: true },
            { key: 'marketing_event', sortable: true },
            // { key: 'filename', sortable: true },
            { key: 'status', sortable: true },
            ],
            sech: {},
            currentPage: 1,
            perPage: 10,
            totalRows: null,
            isBusy: true,
            totalResponse: null,
            permission_upload: false,
            superAdmin: false
    }
  },
  computed: {},
  mounted () {},
  async created() {
    let response = await api.post("users/user-permissions");
        const permissions = [];
            response.data[0].permission.forEach( function(element) {                
                permissions.push(element.action)
            }.bind(this));
            if(permissions.includes("upload_response_event") == true ){
                this.getUploadResponseList();
                this.permission_upload = permissions.includes("upload_response_event");
            }else if(response.data[0].role == 'super_admin'){
                this.getUploadResponseList();
                this.superAdmin = true;
            }else if(permissions.includes("list_event") == true || permissions.includes("add_event") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'List Event'});
            }else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
  },
  watch: {
        currentPage: {
            handler: function(page) {
                this.getUploadResponseList(page);
            }
        }
    },
  methods: {
      makeToast(message = '', title = 'Alert', variant = 'warning') {
          this.toastCount++;
          this.$root.$bvToast.toast(message, {
              title: title,
              variant: variant,
              autoHideDelay: 3000
          });
      },
      async toSort (page = 1)
        {   
            this.isBusy=true;
            this.sech.page = page;
            this.sech.paginateVal = this.perPage;
            this.sech.marketing_event_id = this.$route.params.id;
            let response = await api.post('admin/marketing-event/getUploadResponseList', this.sech);
            if (response.status == 'success') {
                if (response.data != '') {
                    this.items = response.data.data;
                    this.totalResponse = response.data.total;
                    this.currentPage = response.data.current_page;
                    this.perPage = response.data.per_page;
                } else {
                    this.items = [];
                }
            }
            this.isBusy = false;   
        },
      async getUploadResponseList(page) {
            this.isBusy=true;
            this.sech.page = page;
            this.sech.paginateVal = this.perPage;
            this.sech.marketing_event_id = this.$route.params.id;
            let response = await api.post('admin/marketing-event/getUploadResponseList', this.sech);

            if (response.status == 'success') {
                if (response.data != '') {
                    this.items = response.data.data;
                    this.totalResponse = response.data.total;
                    this.currentPage = response.data.current_page;
                    this.perPage = response.data.per_page;

                    this.pageOptions.forEach(element => {
                        if(element.value > this.totalResponse){
                            var indexOf = this.pageOptions.indexOf(element);
                            if( indexOf != 0 )
                            this.pageOptions.splice(indexOf)
                        }
                    });
                    if(this.totalResponse <= 500)
                    this.pageOptions.push({text:'All',value:this.totalResponse});
                } else {
                    this.items = [];
                }
            }
            this.isBusy = false;
        }

  }
}


